import { EditRuleState } from "../hooks/use-edit-rule";

type EditRuleFormProps = {
  state: EditRuleState;
};

const EditRuleForm = (props: EditRuleFormProps) => {
  const editRuleState: EditRuleState = props.state;

  return (
    <div className="w-full my-8">
      <div className="m-6">
        <label className="text-sm tracking-[0.07rem]">RULE NAME</label>
        <input
          className={`rounded p-2 mt-2 border w-full ${
            editRuleState.formState.errors &&
            editRuleState.formState.errors.name
              ? "border-red-600 focus:border-red-600"
              : "border-primary-blue"
          }`}
          {...editRuleState.register("name", { required: true })}
        />
        {editRuleState.formState.errors &&
          editRuleState.formState.errors.name &&
          editRuleState.formState.errors.name.type === "required" && (
            <p className="text-red-500 text-sm">Required</p>
          )}
      </div>
      <div className="m-6">
        <label className="text-sm tracking-[0.07rem]">
          BALLOT LABEL <span className="text-xs">(optional)</span>
        </label>
        <input
          className={`rounded p-2 mt-2 border w-full ${
            editRuleState.formState.errors &&
            editRuleState.formState.errors.ballotlabel
              ? "border-red-600 focus:border-red-600"
              : "border-primary-blue"
          }`}
          {...editRuleState.register("ballotlabel")}
        />
      </div>
      <div className="m-6">
        <label>
          <span className="text-sm tracking-[0.07rem]">DESCRIPTION</span>
          <textarea
            rows={6}
            className={`rounded mt-2 p-2 border w-full ${
              editRuleState.formState.errors &&
              editRuleState.formState.errors.description
                ? "border-red-600 focus:border-red-600"
                : "border-primary-blue"
            }`}
            {...editRuleState.register("description", {
              required: true,
            })}
          />
          {editRuleState.formState.errors &&
            editRuleState.formState.errors.description &&
            editRuleState.formState.errors.description.type === "required" && (
              <p className="text-red-500 text-sm">Required</p>
            )}
        </label>
      </div>
      <div className="m-6">
        <label className="text-sm tracking-[0.07rem]">RULE DETAILS</label>
        <div className="mt-2 p-3 rounded-md border border-gray-400 bg-gray-200">
          {editRuleState.rule!.ruledescription}
        </div>
      </div>
    </div>
  );
};

export default EditRuleForm;
